module.exports = __webpack_public_path__ + "static/img/FTG-logo.61e7b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/FTG-logo.png
// module id = Powe
// module chunks = 1